import React from 'react'

export interface ISearchResultTypeContextExpose {
  isPortal: boolean
}

export const SearchResultTypeContext = React.createContext<ISearchResultTypeContextExpose | undefined>(undefined)

/**
 * useSearchResultTypeContext is a container context that allow use to pass in different behaviour
 * @returns
 */
export const useSearchResultTypeContext = () => {
  const context = React.useContext(SearchResultTypeContext)
  if (context === undefined) {
    throw new Error('useSearchResultTypeContext must be used within a SearchResultTypeContext')
  }
  return context
}
